import { render } from "./BulkActionStatusUpdate.vue?vue&type=template&id=8ad4a80e"
import script from "./BulkActionStatusUpdate.vue?vue&type=script&lang=js"
export * from "./BulkActionStatusUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__